import React from "react";

export default function useTransaksiViewState() {
    const [isCardView, setIsCardView] = React.useState(false);
    const [isModalMutasiOpen, setIsModalMutasiOpen] = React.useState(false);

    const handleCardView = React.useCallback(() => {
        setIsCardView(true);
    }, []);

    const handleListView = React.useCallback(() => {
        setIsCardView(false);
    }, []);

    const handleOpenModalMutasi = React.useCallback(() => {
        setIsModalMutasiOpen(true);
    }, []);

    const handleCloseModalMutasi = React.useCallback(() => {
        setIsModalMutasiOpen(false);
    }, []);

    return {
        isCardView,
        isModalMutasiOpen,
        handleCardView,
        handleCloseModalMutasi,
        handleListView,
        handleOpenModalMutasi,
    };
}
